<template>
  <transition name="no-mode-fade">
    <div class="tab-pane fade show active" id="addBadge" role="tabpanel">
      <b-row>
        <b-col lg="6">
          <div class="form-group">
            <label>{{ $t("announcements.title") }}</label>
            <input type="text" class="form-control" v-model="newItem.title" />
          </div> </b-col
        ><b-col lg="6">
          <div class="form-group">
            <label>{{ $t("announcements.type") }}</label>
            <div class="demo-inline-spacing">
              <b-form-radio v-model="newItem.type" name="type" value="text">
                {{ $t("announcements.text") }}
              </b-form-radio>
              <b-form-radio v-model="newItem.type" name="type" value="sound">
                {{ $t("announcements.sound") }}
              </b-form-radio>
            </div>
          </div>
        </b-col>
        <b-col lg="12">
          <div class="form-group" v-show="newItem.type == 'text'">
            <label>{{ $t("announcements.content") }}</label>
            <ckeditor
              :config="{ contentsLangDirection: 'rtl' }"
              v-model="newItem.content"
            />
          </div>
          <div class="form-group" v-show="newItem.type == 'sound'">
            <label>{{ $t("announcements.sound") }}</label>
            <input
              accept="audio/*"
              @change="onChangeSound($event, 'sound')"
              type="file"
              class="form-control"
            />
          </div> </b-col
        ><b-col lg="6">
          <div class="form-group" v-if="user.account_type == 'admin'">
            <label>{{ $t("announcements.target") }}</label>

            <b-form-select
              v-model="newItem.target"
              :options="targetOptions"
              @input="selectTarget()"
            />
          </div>
          <div class="form-group" v-if="user.account_type != 'admin'">
            <label>{{ $t("announcements.target") }}</label>
            <div class="demo-inline-spacing">
              <b-form-radio
                v-model="newItem.target"
                name="target"
                value="all_students_in_edu_program"
              >
                جميع الطلاب في برنامج التعليم
              </b-form-radio>
              <b-form-radio
                v-model="newItem.target"
                name="target"
                value="all_students_in_room"
              >
                جميع الطلاب في الفصل
              </b-form-radio>
            </div>
          </div>
        </b-col>
        <b-col lg="3">
          <div
            class="form-group"
            v-if="
              user.account_type == 'admin' &&
              [
                'all_students_in_edu_program',
                'all_teachers_in_edu_program',
                'all_students_in_room',
                'all_teachers_in_room',
              ].includes(newItem.target)
            "
          >
            <label>{{ $t("edu_programs.edu_programs") }}</label>

            <b-form-select
              :options="eduPrograms"
              text-field="name"
              value-field="id"
              v-model="newItem.edu_program_id"
              @input="selectEduProgram()"
            />
          </div>
        </b-col>
        <b-col lg="3">
          <div
            class="form-group"
            v-if="
              user.account_type == 'admin' &&
              ['all_students_in_room', 'all_teachers_in_room'].includes(
                newItem.target
              )
            "
          >
            <label>{{ $t("rooms.rooms") }}</label>

            <b-form-select
              v-model="newItem.room_id"
              :options="rooms"
              text-field="name"
              value-field="id"
            />
          </div>
        </b-col>
      </b-row>
      <b-row> 
        <hr />
        <b-col lg="6">
          <div class="form-group">
            <label>{{ $t("announcements.priority") }}</label>
            <div class="demo-inline-spacing">
              <b-form-radio
                v-model="newItem.priority"
                name="some-radios"
                value="1"
              >
                {{ $t("announcements.priority_high") }}
              </b-form-radio>
              <b-form-radio
                v-model="newItem.priority"
                name="some-radios"
                value="2"
              >
                {{ $t("announcements.priority_medium") }}
              </b-form-radio>
              <b-form-radio
                v-model="newItem.priority"
                name="some-radios"
                value="3"
              >
                {{ $t("announcements.priority_low") }}
              </b-form-radio>
            </div>
          </div>
        </b-col>

        <b-col lg="6">
          <div class="form-group">
            <label>{{ $t("announcements.publish_date") }}</label>
            <b-datepicker v-model="newItem.publish_date"></b-datepicker>
          </div>
        </b-col>
        <b-col lg="6">
          <div class="form-group">
            <label>{{ $t("announcements.expiry_date") }}</label>
            <b-datepicker v-model="newItem.expiry_date"></b-datepicker>
          </div>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="6">
          <b-button
            block
            :disabled="invalid"
            variant="primary"
            @click="submit()"
          >
            <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
          >
        </b-col>
        <b-col lg="6">
          <b-button block  @click="goToTable()" variant="success"  >
            <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
          >
        </b-col>
      </b-row>
    </div>
  </transition>
</template>

<script>
import controller from "../../../../Controllers/AnnouncementsController";
import config from "../../../../config/config";
import Auth from "@/Apis/Auth";
import EduProgramsController from "@/Controllers/EduProgramsController";
export default {
  props: ["newItem"],
  data() {
    return {
      url: null,
      targetOptions: [
        {
          value: "all_teachers_and_students",
          text: this.$i18n.t("announcements.all_teachers_and_students"),
        },
        {
          value: "all_teachers",
          text: this.$i18n.t("announcements.all_teachers"),
        },
        {
          value: "all_students",
          text: this.$i18n.t("announcements.all_students"),
        },
        {
          value: "all_students_in_edu_program",
          text: this.$i18n.t("announcements.all_students_in_edu_program"),
        },
        {
          value: "all_students_in_room",
          text: this.$i18n.t("announcements.all_students_in_room"),
        },
        {
          value: "all_teachers_in_edu_program",
          text: this.$i18n.t("announcements.all_teachers_in_edu_program"),
        },
        {
          value: "all_teachers_in_room",
          text: this.$i18n.t("announcements.all_teachers_in_room"),
        },
      ],

      contentBox: true,
      file: {},
      sound: "",
      
      user: {},
      eduPrograms: [],
      eduProgramId: 0,
      rooms: [],
    };
  },

  methods: {
     goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      if (this.user.account_type == "teacher") {
        if (this.newItem.target == "all_students_in_edu_program") {
          this.newItem.edu_program_id = localStorage.getItem("eduProgram");
        } else if (this.newItem.target == "room_id") {
          this.newItem.room_id = localStorage.getItem("room");
        }
      }
      let ret = await new controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },

    onChangeSound(e, field) {
      let _file = e.target.files[0];
      this.newItem[field] = _file;
      this.url = URL.createObjectURL(this.newItem[field]);
    },
    selectTarget() {},
    selectEduProgram(val) {
      let ed = this.eduPrograms.find(
        (a) => a.id == this.newItem.edu_program_id
      );
      this.rooms = ed.rooms;
    },
  },
  created() {
    this.user = Auth.USER;
    new EduProgramsController().GetAll({ with: ["rooms"] }).then((res) => {
      this.eduPrograms = res;
    });
  },
  watch: {},
};
</script>

<style></style>